import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { PaymentTermForm } from "../../features/payment-terms/PaymentTermForm"

type Props = {
  payment_term: { name: string; days: string; active: boolean }
  errors?: Record<string, string[]>
}

export default function DatasPagamentoNew({ payment_term, errors }: Props) {
  return (
    <>
      <Head title="Nova Condição de Pagamento" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Nova Condição de Pagamento</h1>
            <p className="text-slate-400">Cadastre uma nova condição como à vista, 30 dias, 60 dias, etc.</p>
          </div>
          <PaymentTermForm
            initialValues={payment_term}
            submitUrl="/datas-pagamento"
            submitLabel="Criar condição"
            method="post"
            errors={errors}
          />
        </div>
      </AppLayout>
    </>
  )
}
